<template>

  <div class="invite-page">
    <!-- 我的邀请卡片 -->
    <div class="invite-card">
      <div class="invite-icon">
        <van-icon name="friends-o" size="32" color="#8C9EAF" />
      </div>
      <div class="invite-info">
        <div class="invite-title">我的邀请</div>
        <div class="invite-desc">
          已成功邀请 <span class="invite-count">{{ inviteCount }}</span> 位好友
        </div>
      </div>
    </div>
    
    <!-- 邀请列表 -->
    <div class="invite-list" v-if="inviteList.length > 0">
      <!-- 表头 -->
      <div class="list-header-row">
        <div class="col-name">姓名</div>
        <div class="col-company">单位</div>
        <div class="col-phone">手机</div>
      </div>
      <!-- 列表内容 -->
      <div class="list-content">
        <div class="invite-item" v-for="(item, index) in inviteList" :key="index">
          <div class="item-index">{{ index + 1 }}</div>
          <div class="item-name">{{ item.visitorName }}</div>
          <div class="item-company">{{ item.visitorComName }}</div>
          <div class="item-phone">{{ item.visitorMobile }}</div>
        </div>
      </div>
    </div>
    
    <!-- 空状态 -->
    <div class="empty-state" v-else>
      <van-icon name="friends-o" size="48" color="#ddd" />
      <p>暂无邀请记录</p>
    </div>
    
    <!-- 返回按钮 -->
    <div class="back-btn-wrap">
      <van-button 
        block 
        round 
        :color="mainColor" 
        @click="goBack"
      >
        返回
      </van-button>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import step from '@/components/step.vue'
import api from '@/api'
const store = useStore()
const router = useRouter()
const mainColor = computed(() => store.state.mainColor)
const ExhCode = computed(() => store.state.ExhCode)
const VisitorID = computed(() => store.state.VisitorID)
// 邀请统计
const inviteCount = ref(0)

// 邀请列表
const inviteList = ref([])
// 获取邀请列表
const getInvitedList = async () => {
  const res = await api.GetVisitorListApi({
    exhcode: ExhCode.value,
    VisitorID: VisitorID.value
  })
  if (res.data) {
    inviteList.value = res.data
  }
}

onMounted(() => {
  // 滚动到顶部
  window.scrollTo(0, 0)
  
  // 设置主题色
  if (mainColor.value) {
    document.documentElement.style.setProperty('--color-primary', mainColor.value)
  }
  // TODO: 获取邀请数据
  getInvitedList()
})

// 返回成功页面
const goBack = () => {
  router.push('/success')
}
</script>

<style lang="less" scoped>
@import '../../assets/login.less';

.invite-page {
  min-height: 100vh;
  background: #F5F7FA;
  padding: 16px;
}

// 我的邀请卡片
.invite-card {
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border-top: 4px solid var(--color-primary, #E60044);
  
  .invite-icon {
    width: 56px;
    height: 56px;
    background: #F0F4F8;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 16px;
  }
  
  .invite-info {
    flex: 1;
  }
  
  .invite-title {
    font-size: 17px;
    font-weight: 600;
    color: #333;
    margin-bottom: 6px;
  }
  
  .invite-desc {
    font-size: 14px;
    color: #666;
    
    .invite-count {
      color: var(--color-primary, #E60044);
      font-weight: 600;
      font-size: 18px;
      margin: 0 2px;
    }
  }
}

// 邀请列表
.invite-list {
  background: #fff;
  border-radius: 12px;
  margin-top: 16px;
  overflow: hidden;
}

// 表头
.list-header-row {
  display: flex;
  align-items: center;
  padding: 14px 16px 14px 40px;
  border-bottom: 1px solid #E0E0E0;
  
  .col-name {
    width: 25%;
    text-align: left;
    font-size: 15px;
    font-weight: 600;
    color: #333;
  }
  
  .col-company {
    flex: 1;
    text-align: center;
    font-size: 15px;
    font-weight: 600;
    color: #333;
  }
  
  .col-phone {
    width: 25%;
    text-align: right;
    font-size: 15px;
    font-weight: 600;
    color: #333;
  }
}

// 列表项
.invite-item {
  display: flex;
  align-items: center;
  padding: 14px 16px;
  border-bottom: 1px solid #F5F5F5;
  
  .item-index {
    width: 24px;
    height: 24px;
    background: var(--color-primary, #E60044);
    color: #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 500;
    margin-right: 10px;
    flex-shrink: 0;
  }
  
  .item-name {
    width: 25%;
    font-size: 14px;
    color: #333;
    text-align: left;
  }
  
  .item-company {
    flex: 1;
    font-size: 14px;
    color: #333;
    text-align: center;
  }
  
  .item-phone {
    width: 25%;
    font-size: 14px;
    color: #333;
    text-align: right;
  }
  
  &:last-child {
    border-bottom: none;
  }
}

// 空状态
.empty-state {
  margin-top: 16px;
  padding: 60px 0;
  text-align: center;
  background: #fff;
  border-radius: 12px;
  
  p {
    margin-top: 12px;
    font-size: 14px;
    color: #999;
  }
}

// 返回按钮
.back-btn-wrap {
  margin-top: 24px;
  padding: 0 16px;
}
</style>
